import { useQuery } from '@tanstack/react-query'
import { ContentPerformanceMockData } from 'src/pages/ContentAnalysisDetail/mockData/contentPerformanceMockData'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisApiService } from 'src/services/contentAnalysisApi'

interface ContentPerformanceResponse {
  data: ContentPerformanceMockData
}

interface UseGetContentAnalysisContentPerformanceQueryParams {
  fromDate?: string
  id: string
  toDate?: string
}

export const useGetContentAnalysisContentPerformanceQuery = ({
  fromDate,
  id,
  toDate,
}: UseGetContentAnalysisContentPerformanceQueryParams) => {
  return useQuery({
    enabled: !!id,
    queryFn: () =>
      ContentAnalysisApiService.getContentPerformance<ContentPerformanceResponse>(
        id,
        { fromDate, toDate }
      ),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_CONTENT_PERFORMANCE,
      id,
      fromDate,
      toDate,
    ],
  })
}
